import React, { useEffect, useRef, useState } from 'react';
import { ButtonBase, Divider, Typography } from '@material-ui/core';
import clsx from 'clsx';
import FilterIcon from "../../assets/images/filterMenuIcon.svg";
import { useStyles } from "../../assets/jss/DriverDetailsTabTrips";
import DateTime from "../DateTime/DateTime";
import CustomBox from '../CustomComponents/CustomBox/CustomBox';
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import { useTranslation } from 'react-i18next';
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { getDriverTripList } from "../../services/DriverTripList";
import SeverityIcon from "../../assets/images/severity.svg";
import Map from "../DriverLocator/Map";
import DriverTripCard from '../DriverTrips/DriverTripCard';
import FilterActionDialog from '../Dialogs/FilterDriver/FilterAction';
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import SwitchTripDialog from '../Dialogs/SwitchTrip/SwitchTrip';
import { Role, speedSeverityType, TripTypeEnum } from "../../config/app-globals.enum";
import DriverTripEventCard from '../DriverTrips/DriverTripEventCard';
import Draggable from 'react-draggable';
import CustomButton from '../CustomComponents/CustomButton/CustomButton';
import { getUserData } from '../../services/LocalStorageService';

export default function DriverDetailsTabTrips(props: any) {
	const classes = useStyles();
	const { t } = useTranslation();
	const leftDrawerContainer = useRef<any>();
	const [isApi, setIsApi] = React.useState(true);
	const [showLoading, setShowLoading] = React.useState(true);
	const [showNoRecordFounds, setShowNoRecordFounds] = React.useState(false);
	const [tripList, setTripList] = useState([]);
	const [filteredTripList, setFilteredTripList] = useState([]);
	const [userId] = useState(props.userId);
	const [searchKey] = React.useState('');
	const [selectedTrip, setSelectedTrip] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [locationData, setLocationData] = useState(null);
	const [isFilterDialogOpened, setIsFilterDialogOpened] = useState(false);
	const [isSwitchTripDialogOpened, setIsSwitchTripDialogOpened] = useState(false);
	const [isFreshCall, setIsFreshCall] = useState(false);
	const [isMapInitialized, setIsMapInitialized] = useState(false);
	const [expandDriverCard, setExpandDriverCard] = useState(true);
	const [userData] = React.useState(getUserData());

	const [selectedFilters, setSelectedFilters] = useState({
		modalTypesOfEvents: [],
		modalSeverityEvents: [],
		modalSpeedingEventSeverityTypes: []
	});
	const [expandDrawer, setExpandDrawer] = useState(true);
	const [showMissingTrips, setShowMissingTrips] = useState(false);

	useEffect(() => {
		if (leftDrawerContainer && leftDrawerContainer.current) {
			if (expandDrawer) {
				leftDrawerContainer.current.style.left = 0;
			} else {
				leftDrawerContainer.current.style.left = `-${leftDrawerContainer.current.offsetWidth}px`;
			}
		}
	}, [expandDrawer]);

	useEffect(() => {
		try {
			document.getElementById("praisoCopyrightText").style['display'] = 'none';
		} catch (error) {

		}
		return () => {
			try {
				document.getElementById("praisoCopyrightText").style['display'] = 'inherit';
			} catch (error) {

			}
		}
	}, [])

	useEffect(() => {
		if (isFreshCall) {
			loadData();
		}
	}, [isFreshCall]);

	useEffect(() => {
		loadData();
	}, []);

	useEffect(() => {
		handleFilterData();
	}, [tripList, searchKey, selectedFilters]);

	useEffect(() => {
		loadData();
	}, [showMissingTrips])

	const handleFilterData = () => {
		setSelectedEvent(null);
		let result = []
		if (tripList.length > 0) {
			if ((selectedFilters.modalTypesOfEvents && selectedFilters.modalTypesOfEvents.length > 0) || (selectedFilters.modalSeverityEvents && selectedFilters.modalSeverityEvents.length > 0) || (selectedFilters.modalSpeedingEventSeverityTypes && selectedFilters.modalSpeedingEventSeverityTypes.length > 0)) {
				setSelectedTrip(null);
				/**Filter trip data as per event types */
				if (selectedFilters.modalTypesOfEvents && selectedFilters.modalTypesOfEvents.length > 0) {
					let childEvents = props.eventTypes.filter(el => selectedFilters.modalTypesOfEvents.includes(+el.parentEventTypeId));
					let eventTypeIds = childEvents.map(el => el.id);
					for (let i = 0; i < tripList.length; i++) {
						const trip = tripList[i];
						const events = trip.eventList.filter(item => eventTypeIds.includes(item.eventTypeId));
						if (events.length > 0) {
							result.push(trip);
						}
					}
					/**Filter trip data as per speeding severity types */
					if (selectedFilters.modalSpeedingEventSeverityTypes && selectedFilters.modalSpeedingEventSeverityTypes.length > 0) {
						let speedingSeverityEventList = [];
						let tripData = tripList;
						if (result.length > 0) {
							speedingSeverityEventList = result;
						}
						if (selectedFilters.modalSpeedingEventSeverityTypes.length > 0) {
							for (let i = 0; i < selectedFilters.modalSpeedingEventSeverityTypes.length; i++) {
								let severity = selectedFilters.modalSpeedingEventSeverityTypes[i];
								if (severity == speedSeverityType.MOTORWAYSPEEDING) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isMotorWaySpeeding === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
								if (severity == speedSeverityType.SCHOOLRUNSPEEDING) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isSchoolRunSpeeding === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
								if (severity == speedSeverityType.DRIVINGBAN) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isDrivingBan === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
							}
							result = speedingSeverityEventList;
						}

					}
					if (result.length === 0) {
						setFilteredTripList(result);
						setShowNoRecordFounds(true);
						return;
					}
				} else if (selectedFilters.modalTypesOfEvents.length === 0) {
					/**Filter trip data as per speeding severity types */
					if (selectedFilters.modalSpeedingEventSeverityTypes && selectedFilters.modalSpeedingEventSeverityTypes.length > 0) {
						let speedingSeverityEventList = [];
						let tripData = tripList;
						if (result.length > 0) {
							speedingSeverityEventList = result;
						}
						if (selectedFilters.modalSpeedingEventSeverityTypes.length < 3) {
							for (let i = 0; i < selectedFilters.modalSpeedingEventSeverityTypes.length; i++) {
								let severity = selectedFilters.modalSpeedingEventSeverityTypes[i];
								if (severity == speedSeverityType.MOTORWAYSPEEDING) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isMotorWaySpeeding === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
								if (severity == speedSeverityType.SCHOOLRUNSPEEDING) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isSchoolRunSpeeding === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
								if (severity == speedSeverityType.DRIVINGBAN) {
									for (let j = 0; j < tripData.length; j++) {
										const trip = tripData[j];
										const events = trip.eventList.filter(item => item.isDrivingBan === true);
										if (events.length > 0) {
											speedingSeverityEventList.push(trip);
										}
									}
								}
							}
							result = speedingSeverityEventList;
						}
					}
				}
				/**Filter trip data as per event severity types */
				if (selectedFilters.modalSeverityEvents && selectedFilters.modalSeverityEvents.length > 0) {
					let severityEventList = [];
					let tripData = tripList;
					if (result.length > 0) {
						tripData = result;
					}
					for (let i = 0; i < tripData.length; i++) {
						const trip = tripData[i];
						const events = trip.eventList.filter(item => selectedFilters.modalSeverityEvents.includes(item.severity));
						if (events.length > 0) {
							severityEventList.push(trip);
						}
					}
					result = severityEventList;
				}


			} else {
				result = tripList;
				setSelectedTrip(tripList[0]);
			}
			// Check for search
			if (searchKey.length > 0) {
				setSelectedTrip(null);
				const searchResult = result.filter((item) => {
					if (item && item !== undefined) {
						const address = `${item.formattedStartAddress} ${item.formattedEndAddress}`;
						if (address.toLowerCase().includes(searchKey.toLowerCase())) {
							return item;
						}
					}
				});
				if (searchResult && searchResult.length > 0) {
					result = searchResult;

				} else {
					result = [];
				}
			}
			setFilteredTripList(result);
			if (result.length > 0) {
				setSelectedTrip(result[0]);
			}
			if (result.length === 0) {
				setShowNoRecordFounds(true);
				setSelectedTrip(null);
			}
		} else if (!isApi) {
			setShowNoRecordFounds(true);
			setSelectedTrip(null);
			setFilteredTripList([]);
		}
	}

	async function loadData() {
		// setStatusValue(null);
		// setAlertMessage("");
		// setIsAlertOpen(false);
		setIsApi(true);
		setShowLoading(true);

		var params = {
			userId: userId,
			isFreshCall: true,
			tripTypes: showMissingTrips ? [TripTypeEnum.NOT_DRIVING, TripTypeEnum.OTHER] : []
		};
		// params.userId = userId;
		// params.isFreshCall = true;  //isFreshCall;
		const data = await getDriverTripList(params);
		setIsFreshCall(false);
		setIsApi(false);
		setShowLoading(false);
		if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
			if (data.content.length > 0) {
				data.content.sort((a, b) => new Date(b.endTime).getTime() - new Date(a.endTime).getTime());
				for (let i = 0; i < data.content.length; i++) {
					const trip = data.content[i];
					const startAddress = getAddressFromObject(trip.startAddress);
					const endAddress = getAddressFromObject(trip.endAddress);
					trip['formattedStartAddress'] = startAddress;
					trip['formattedEndAddress'] = endAddress;
				}
				setSelectedTrip(data.content[0]);
			} else {
				setSelectedTrip(null);
			}
			setTripList(data.content);
		}
	}

	const getAddressFromObject = (addressObject) => {
		let address = '';
		try {
			if (addressObject) {
				if (addressObject.subLocality !== undefined && addressObject.subLocality !== null) {
					address += addressObject.subLocality + ', ';
				}
				if (addressObject.locality !== undefined && addressObject.locality !== null) {
					address += addressObject.locality + ', ';
				}
				if (addressObject.subAdminArea !== undefined && addressObject.subAdminArea !== null) {
					address += addressObject.subAdminArea + ', ';
				}
				if (addressObject.adminArea !== undefined && addressObject.adminArea !== null) {
					address += addressObject.adminArea + ', ';
				}
				if (addressObject.countryName !== undefined && addressObject.countryName !== null) {
					address += addressObject.countryName + ', ';
				}
				if (addressObject.postalCode !== undefined && addressObject.postalCode !== null) {
					address += addressObject.postalCode;
				}
				// if(addressObject.featureName !== undefined && addressObject.featureName !== null){
				// 	address += addressObject.featureName + ', ';
				// }
				// if(addressObject.countryCode !== undefined && addressObject.countryCode !== null){
				// 	address += addressObject.countryCode + ', ';
				// }
				// Object.values(addressObject).map((value) => {
				// 	if (value && (typeof value === 'string')) {
				// 		address += value + ', ';
				// 	}
				// })
			}
		} catch (error) {

		}
		return address === '' ? t(`LOCATION_DATA_NOT_FOUND`) : address; //address.replace(/, +$/, '');
	}

	return <>
		<CustomGrid container className={classes.mainContainer}>
			<CustomGrid container className={classes.mapsContainer}>
				<CustomGrid item xs={12}>
					<Map {...props} selectedTrip={selectedTrip} selectedEvent={selectedEvent} setSelectedTrip={setSelectedTrip} setSelectedEvent={setSelectedEvent} locationData={locationData} setIsMapInitialized={setIsMapInitialized}
						isMapInitialized={isMapInitialized} />
				</CustomGrid>
			</CustomGrid>
			<div ref={leftDrawerContainer} className={classes.leftDrawerContainer}>
				<CustomBox className={classes.tripsListBoxContainer}>
					<CustomBox className={classes.searchBox}>
						<CustomBox className={classes.sideBarSearchView}>
							{/* <CustomTextField placeholder={t("Search by Vehicle, Date, Time")} fullWidth className={classes.search} value={searchKey} onChange={handleSearch}
                                InputProps={{
                                    startAdornment: (
                                        <CustomInputAdornment position='start'>
                                            <CustomIconButton style={{ padding: 8 }}>
                                                <img src={SearchIcon} alt="Search" className={classes.searchIcon} />
                                            </CustomIconButton>
                                        </CustomInputAdornment>
                                    ),
                                }}
                            /> */}
							{!showLoading && userData.userRoleId === Role.DRIVER && <>
								{
									showMissingTrips ?
										<CustomButton onClick={() => setShowMissingTrips(false)}>
											View active trips
										</CustomButton>
										:
										<CustomButton onClick={() => setShowMissingTrips(true)}>
											View missing trips
										</CustomButton>
								}
							</>
							}
							<CustomIconButton className={classes.filterIcon} onClick={() => setIsFilterDialogOpened(true)}>
								<img src={FilterIcon} height={24} width={24} />
							</CustomIconButton>
						</CustomBox>
					</CustomBox>
					<CustomBox className={classes.tripsListBox}>
						{showLoading && <CustomPaper elevation={0} square className={classes.driverInfoCard} style={{ textAlign: 'center' }} >
							<CustomCircularProgress style={{ margin: "0 auto" }} />
						</CustomPaper>}
						{
							filteredTripList && filteredTripList.map((trip, index) => {
								return <ButtonBase key={index} component="div" style={{ display: 'block' }} onClick={() => { setSelectedEvent(null); setSelectedTrip(trip); setExpandDriverCard(true) }}>
									<CustomBox className={clsx(classes.tripsListItem, (selectedTrip && selectedTrip.tripId === trip.tripId ? classes.tripsListItemSelected : null))}>
										<CustomBox className={classes.tripsListItemRow}>
											<CustomBox className={classes.tripsListItemIconBox}>
												<CustomBox className={clsx(classes.tripsListItemIconStart)}>
												</CustomBox>
												<CustomBox className={classes.dottedLine}></CustomBox>
											</CustomBox>
											<CustomBox className={classes.tripsListItemSideBox}>
												<CustomBox className={trip.formattedStartAddress === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
													{trip.formattedStartAddress}
												</CustomBox>
												<CustomBox className={classes.eventDate}>
													<DateTime inputDate={trip.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={trip.startTime} returnFormat="hh:mm A" />
												</CustomBox>
											</CustomBox>
										</CustomBox>
										<CustomBox className={classes.tripsListItemRow}>
											<CustomBox className={classes.tripsListItemIconBox}>
												<CustomBox className={clsx(classes.tripsListItemIconEnd)}>

												</CustomBox>
											</CustomBox>
											<CustomBox className={classes.tripsListItemSideBox}>
												<CustomBox className={trip.formattedEndAddress === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
													{trip.formattedEndAddress}
												</CustomBox>
												<CustomBox className={classes.eventDate}>
													<DateTime inputDate={trip.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={trip.endTime} returnFormat="hh:mm A" />
												</CustomBox>
											</CustomBox>
										</CustomBox>
										<CustomBox className={clsx(classes.tripsListItemRow, classes.tripsListItemRowCenter)}>
											<CustomGrid container alignItems="center">
												<CustomGrid item className={clsx(classes.eventsSeverityIcon, classes.eventsIcon)}>
													<img className={classes.eventsIcon} src={SeverityIcon} />
												</CustomGrid>
												<CustomGrid item className={classes.eventsSeverityCount}>
													{trip.severityCount}
												</CustomGrid>
											</CustomGrid>
											{trip.tripType === 0 && <CustomBox className={classes.eventsType}>
												{t(`PERSONAL_TRIP`)}
											</CustomBox>}

										</CustomBox>
									</CustomBox>
									<Divider light />
								</ButtonBase>

							})}
						{
							!showLoading && showNoRecordFounds && filteredTripList && filteredTripList.length === 0 && <Typography component="div" style={{ textAlign: 'center' }}>
								{t(`No Records found.`)}
							</Typography>
						}
					</CustomBox>
				</CustomBox>
				<CustomBox className={classes.leftDrawerContainerButtonBox} onClick={() => { setExpandDrawer(!expandDrawer) }} >
					{expandDrawer ? <ArrowBackIosIcon className={classes.leftDrawerContainerButtonIcon} /> : <ArrowForwardIosIcon className={classes.leftDrawerContainerButtonIcon} />}
				</CustomBox>
			</div>

			<Draggable bounds="parent">
				<CustomBox className={classes.rightMainContainer}>
					{/* <CustomBox className={classes.tripCardDrawerButton} onClick={() => { cardDrawerClick() }} >
						{cardExpandDrawer ? <ArrowBackIosIcon className={classes.leftDrawerContainerButtonIcon} /> : <ArrowForwardIosIcon className={classes.leftDrawerContainerButtonIcon} />}
					</CustomBox> */}
					{selectedEvent === null && selectedTrip &&
						<DriverTripCard selectedTrip={selectedTrip} setSelectedTrip={setSelectedTrip} getAddressFromObject={getAddressFromObject} setIsSwitchTripDialogOpened={setIsSwitchTripDialogOpened} expandDriverCard={expandDriverCard} setExpandDriverCard={setExpandDriverCard} />
					}
					{selectedEvent && <DriverTripEventCard selectedEvent={selectedEvent} selectedTrip={selectedTrip} setSelectedEvent={setSelectedEvent} getAddressFromString={getAddressFromObject} />}
				</CustomBox>
			</Draggable>
			<FilterActionDialog selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} dialogOpen={isFilterDialogOpened} dialogClose={() => setIsFilterDialogOpened(false)} />
			<SwitchTripDialog selectedTrip={selectedTrip} setIsFreshCall={setIsFreshCall} setSelectedTrip={setSelectedTrip} userId={userId} dialogOpen={isSwitchTripDialogOpened} dialogClose={() => setIsSwitchTripDialogOpened(false)} />
		</CustomGrid>
	</>
}